import React from "react";
import DashboardShell from "../../components/DashboardShell";
import LivePlayground from "../../components/LivePlayground";

export default function Playground() {
  return (
    <DashboardShell title="Gateway Playground" subtitle="Send synthetic requests through the live Sentry Gateway.">
      <div className="max-w-3xl">
        <LivePlayground dark />
      </div>
      <div className="mt-6 rounded-xl bg-white/5 border border-white/10 p-5 max-w-3xl">
        <div className="eyebrow text-[#FFD98A] mb-2" style={{fontSize:10}}>CURL EQUIVALENT</div>
        <pre className="font-mono text-xs text-cream/85 overflow-x-auto whitespace-pre-wrap">{`curl -X POST $BACKEND/api/v1/gateway/evaluate \\
  -H "Authorization: Bearer $SENTRY_TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{ "prompt": "...", "model": "gpt-4", "provider": "openai" }'`}</pre>
      </div>
    </DashboardShell>
  );
}
